import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=8eede8aa&scoped=true&"
import script from "./BlockUser.vue?vue&type=script&lang=js&"
export * from "./BlockUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockUser.vue?vue&type=style&index=0&id=8eede8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eede8aa",
  null
  
)

export default component.exports